import * as React from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';

interface Props {
  onCancel: () => void;
  onSubmit: (data: { bulkImageId: string }) => void;
}

const BulkImageSchema = Yup.object().shape({
  bulkImageId: Yup.string().required('Required'),
});

export function CustomerBulkImageIdForm(props: Props) {
  const { onCancel, onSubmit } = props;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Formik
            initialValues={{ bulkImageId: '' }}
            validationSchema={BulkImageSchema}
            onSubmit={values => onSubmit(values)}
          >
            {({ handleSubmit }) => (
              <Form>
                <div className="form-group">
                  <label>Bulk Image ID</label>
                  <Field name="bulkImageId" className="form-control mb-3" placeholder="Enter bulkImageId" />
                  <ErrorMessage component="div" className="alert alert-danger" name="bulkImageId" />
                </div>

                <Button onClick={onCancel} text="Cancel" customClass="btn btn-secondary mt-3 mb-3 mr-3" />
                <Button
                  onClick={handleSubmit}
                  text="Add Images"
                  customClass="btn btn-primary mt-3 mb-3"
                  type="submit"
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
